var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{attrs:{"icon":'calendar',"heading":_vm.label}},[_vm._v("\n  Countdown\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }